export const getInitialState = () => ({
  // From the service (parsed) - start
  contents: [],
  contentsByUserPreferences: [], // IN PAGE
  videoContents: [],
  userPreferences: [],
  allUserPreferences: [],
  widgetPreferences: [],
  widgetHeading: '',
  messages: [],
  // From the service (parsed) - end
  error: null,
  isLoading: true,
  showPreferencesList: false,
  isMutationPending: false,
  isSubscriptionPending: false,
  isQueryPending: false,
  isMutationPrivacyPending: false,
  unsubscribe: null,
  selectedOptions: [],
});
